import type { Timestamp } from 'firebase/firestore'

// One entry in a meal's cook log at users/{uid}/meal_log/{entryId}: a cook, a note, or both.
// An entry tied to a plan's dinner uses its cookId as its ID, so a cook is never logged twice.
export interface MealLogEntryDoc {
  mealId: string
  createdAt: Timestamp
  text?: string
  cooked: boolean
  planId?: string
  cookId?: string
}

export type MealLogInput = Omit<MealLogEntryDoc, 'createdAt'>

// The fields to write, with the note trimmed, or null when the entry would hold nothing.
export function mealLogFields(input: MealLogInput): MealLogInput | null {
  const text = input.text?.trim()
  if (!text && !input.cooked) return null
  return {
    mealId: input.mealId,
    cooked: input.cooked,
    ...(text ? { text } : {}),
    ...(input.planId ? { planId: input.planId } : {}),
    ...(input.cookId ? { cookId: input.cookId } : {})
  }
}
